// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
// Utils
import { formFlattenedObject, formFlattenedParamString, serializeObjectSortedKeys } from 'NewAngular/utils/urls';
// Constants
import { PORTFOLIO_OPTIMIZER_DATA_KEYS } from 'PortfolioOptimizerApp/features/correlation-matrix-heatmap/constants';
import { SAVED_PORTFOLIO_OPTIMIZER_MINIMUM_STATE_KEYS, SAVED_PORTFOLIO_OPTIMIZER_STATE_KEYS, } from 'PortfolioOptimizerApp/apps/portfolio-optimizer-app/state/constants';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class PortfolioOptimizerService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getBaselinePortfolioInfo(baselinePortfolioId) {
        /**
         * `securityIds` represents a string of comma delimited symbols, e.g. "AAPL,GOOG,TSLA" or just "AAPL"
         */
        const urlParams = { baselinePortfolioId };
        const url = this.urlsService.getUrl(this.urlsService.PORTFOLIO_OPTIMIZER.BASELINE_PORTFOLIO_INFO, urlParams);
        return this.ajaxService.getDataObserveBody(url);
    }
    getCorrelationMatrixURL(params) {
        const chartUrlParams = this.getPortfolioOptimizerQuery(params);
        const chartDataBaseUrl = this.urlsService.PORTFOLIO_OPTIMIZER.CORRELATION_MATRIX_DATA;
        return `${this.urlsService.getUrl(chartDataBaseUrl)}?${chartUrlParams}`;
    }
    getEfficientFrontierURL(params) {
        const chartUrlParams = this.getPortfolioOptimizerQuery(params);
        const chartDataBaseUrl = this.urlsService.PORTFOLIO_OPTIMIZER.EFFICIENT_FRONTIER_DATA;
        return `${this.urlsService.getUrl(chartDataBaseUrl)}?${chartUrlParams}`;
    }
    getPortfolioOptimizerQuery(params) {
        const serializedKeys = PORTFOLIO_OPTIMIZER_DATA_KEYS;
        return formFlattenedParamString(params, serializedKeys, true);
    }
    getCorrelationMatrixDataFromUrl(url) {
        return this.ajaxService.getDataObserveBody(url);
    }
    getEfficientFrontierData(params) {
        const flattenedObject = formFlattenedObject(params, PORTFOLIO_OPTIMIZER_DATA_KEYS);
        return this.ajaxService.postFormEncodedDataObserveBody(this.urlsService.PORTFOLIO_OPTIMIZER.EFFICIENT_FRONTIER_DATA, flattenedObject);
    }
    getPortfolioGrowthAndPerformanceData(growthAndPerformanceFetchParams) {
        const serializedArguments = {
            ...growthAndPerformanceFetchParams,
            optimizedWeightings: serializeObjectSortedKeys(growthAndPerformanceFetchParams.optimizedWeightings),
        };
        const url = this.urlsService.PORTFOLIO_OPTIMIZER.GROWTH_AND_PERFORMANCE_DATA;
        return this.ajaxService.getDataObserveBody(url, serializedArguments);
    }
    /**
     * Returns the Correlation Matrix PDF Report URL
     *
     * @param reportTitle: Title to add to the report.
     * @param withCorrelationPoints: display value for each heatmap box.
     * @param portfolioOptimizerParams: PortfolioOptimizerState object.
     * @param securityIds: optional list of security IDs.
     * @param includeLegend: include security legend alongside the matrix.
     */
    getCorrelationMatrixPdfReportUrl(reportTitle, withCorrelationPoints, portfolioOptimizerParams, securityIds, includeLegend) {
        let url = this.urlsService.PORTFOLIO_OPTIMIZER.CORRELATION_MATRIX_PDF_REPORT;
        const urlParams = formFlattenedParamString({
            ...portfolioOptimizerParams,
            reportTitle,
            withCorrelationPoints,
            securityIds,
            includeLegend,
        }, [
            ...SAVED_PORTFOLIO_OPTIMIZER_STATE_KEYS,
            'reportTitle',
            'withCorrelationPoints',
            'securityIds',
            'includeLegend',
        ]);
        url = `${url}?${urlParams}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    /**
     * Returns the Efficient Frontier PDF Report URL
     *
     * @param reportTitle: Title to add to the report.
     * @param portfolioOptimizerParams: PortfolioOptimizerState object.
     * @param assetLabelType: ChartOptionType assetls label display option.
     */
    getEfficientFrontierPdfReportUrl(reportTitle, portfolioOptimizerParams, assetLabelType) {
        const url = this.urlsService.PORTFOLIO_OPTIMIZER.EFFICIENT_FRONTIER_PDF_REPORT;
        const params = { ...portfolioOptimizerParams, reportTitle, assetLabelType };
        const flattenedParams = formFlattenedObject(params, [
            ...SAVED_PORTFOLIO_OPTIMIZER_STATE_KEYS,
            'reportTitle',
            'optimizedWeightings',
            'assetLabelType',
            'selectedPortfolio',
            'comparisonPortfolios',
        ]);
        return this.ajaxService.postJsonDataObserveBody(url, flattenedParams);
    }
    addComparisonPortfolio(portfolioOptimizerParams, baselinePortfolioId) {
        let url = this.urlsService.PORTFOLIO_OPTIMIZER.COMPARISON_PORTFOLIO;
        const urlParams = formFlattenedParamString({ ...portfolioOptimizerParams, baselinePortfolioId }, [
            ...SAVED_PORTFOLIO_OPTIMIZER_MINIMUM_STATE_KEYS,
        ]);
        url = `${url}?${urlParams}`;
        return this.ajaxService.getDataObserveBody(url);
    }
}
PortfolioOptimizerService.ɵfac = function PortfolioOptimizerService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PortfolioOptimizerService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
PortfolioOptimizerService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PortfolioOptimizerService, factory: PortfolioOptimizerService.ɵfac, providedIn: 'root' });
